import * as Separator from '@radix-ui/react-separator'

export interface TitleSeparatorProps {
  title: string
}

export function TitleSeparator({ title }: TitleSeparatorProps) {
  return (
    <div className="flex items-center">
      <Separator.Root className="h-px flex-1 bg-bios-primary" />
      <h1 className="title px-8">{title}</h1>
      <Separator.Root className="h-px flex-1 bg-bios-primary" />
    </div>
  )
}
